import React from 'react';

const play = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117 117">

      <g fill="none" fillRule="nonzero">
        <path fill="#FFF" d="M58.5 117a58.5 58.5 0 1 1 0-117 58.5 58.5 0 0 1 0 117zm0-4a54.5 54.5 0 1 0 0-109 54.5 54.5 0 0 0 0 109z"/>
        <circle cx="58.5" cy="58.5" r="54.5" fill="#000" opacity=".4"/>
        <path fill="#FFF" d="M74.3 37c1.7 0 2.8 1.1 2.8 3.1v38c0 2-1 2.9-2.8 2.9H68c-1.8 0-3-1-3-2.8V40c0-2 1.1-3 3-3h6.3zM49.3 37c1.6 0 2.7 1.1 2.7 3v38.2c0 1.8-1 2.8-2.7 2.8H43c-1.8 0-3-1.1-3-2.8V40c0-2 1-3.1 3-3.1h6.3z"/>
      </g>
    </svg>
  );
};

export default play;


// WEBPACK FOOTER //
// ./src/components/svg-icons/PauseIcon.jsx